export default __webpack_public_path__ + "static/media/noimage.5c2865e7.svg";